import api from './api';

/**
 * Fetches security notification settings from the backend
 * @returns {Promise<Object>} Security notification settings
 */
export const getSecurityNotificationSettings = async () => {
  try {
    const response = await api.get('/settings/security/notifications');
    return response.data;
  } catch (error) {
    console.error('Error fetching security notification settings:', error);
    throw error;
  }
};

/**
 * Updates security notification settings in the backend
 * @param {Object} settings - The updated settings object
 * @returns {Promise<Object>} Updated security notification settings
 */
export const updateSecurityNotificationSettings = async (settings) => {
  try {
    const response = await api.put('/settings/security/notifications', settings);
    return response.data;
  } catch (error) {
    console.error('Error updating security notification settings:', error);
    throw error;
  }
};

/**
 * Fetches all security settings (including notifications) from the backend
 * @returns {Promise<Object>} All security settings
 */
export const getAllSecuritySettings = async () => {
  try {
    const response = await api.get('/api/v1/security/settings');
    return response.data;
  } catch (error) {
    console.error('Error fetching all security settings:', error);
    throw error;
  }
};
